{
    "Budō Lineage Tree": "武术家谱",
    "Teachers" : "教师",
    "Students": "学生",
    "Rank": "等级",
    "Sources": "来源",
    "Tree": "来源",
    "Persons": "个人",
    "Styles": "武术风格",
    "All Styles": "武术风格",
    "Timeline": "时间线",
    "A timeline of Budōka": "武术时间线"
}
